import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { datadogRum } from '@datadog/browser-rum';
import { envConfig } from './env-config';
import { restoreRumUserFromStorage } from './app/shared/utils/rum-user.util';
import { buildRumInitConfiguration, reportBootstrapError } from './app/shared/utils/rum-init.util';

function initDatadog(runtime: Record<string, string> | null) {
  const cfg = buildRumInitConfiguration(runtime, envConfig);
  if (!cfg) return;
  datadogRum.init(cfg);
  // Recarga con sesión activa: identificar antes de la primera vista.
  void restoreRumUserFromStorage();
}

// Bootstrap Angular de inmediato — NO bloquear el primer render esperando el
// fetch de config.json. La config de la app se carga por APP_INITIALIZER.
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(reportBootstrapError);

// Datadog RUM se inicializa en paralelo (runtime config.json si existe, si no
// env-config.ts). No bloquea el arranque de la app.
fetch('/assets/config.json')
  .then(res => res.ok ? res.json() : Promise.reject())
  .then(runtime => initDatadog(runtime))
  .catch(() => initDatadog(null));
